import { Dispatch, FC, SetStateAction } from 'react';

import { TypePlayGeniusOrder } from '@/lib/api/orderManager/types/TypePlayGeniusOrder';
import { TypeExternalPaymentMethod } from '@/lib/api/productCatalog/types';
import { TypeSubEngineInstallment } from '@/lib/api/subscriptionManager/types';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { OrderDetails } from './components/OrderDetails';
import OrderInsights from './components/OrderInsights/OrderInsights';
import { ProductInfo } from './components/ProductInfo';
import { TypeProduct } from '@/core/generated-types/TypeProduct';

type BoxProps = {
  t: TypeAccountERCTranslations;
  orderData?: TypePlayGeniusOrder;
  installmentData?: TypeSubEngineInstallment;
  setInstallmentData?: Dispatch<SetStateAction<TypeSubEngineInstallment>>;
  productData?: TypeProduct;
  paymentMethodData?: TypeExternalPaymentMethod;
  isCurrentBox?: boolean;
  isNextOrder?: boolean;
  isUpcomingBox?: boolean;
  isPausedBox?: boolean;
};

const Box: FC<BoxProps> = ({
  t,
  orderData,
  installmentData,
  setInstallmentData,
  productData,
  paymentMethodData,
  isCurrentBox,
  isNextOrder,
  isUpcomingBox,
  isPausedBox,
}) => (
  <div data-testid="box">
    {(isCurrentBox || isNextOrder) && orderData && (
      <OrderInsights
        t={t}
        orderData={orderData}
        installmentData={installmentData}
        paymentMethodData={paymentMethodData}
        isNextOrder={!!isNextOrder}
      />
    )}

    <div className="p-6 md:p-8 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.16)]">
      {productData && (
        <ProductInfo
          t={t}
          product={productData}
          installment={installmentData}
          setInstallment={setInstallmentData}
          isCurrentBox={isCurrentBox}
          isNextOrder={isNextOrder}
          isUpcomingBox={isUpcomingBox}
          isPausedBox={isPausedBox}
        />
      )}

      {isNextOrder && orderData && <OrderDetails t={t} orderData={orderData} />}
    </div>
  </div>
);

export default Box;
